import { regexConstants } from "../constants/regEx";

export function checkApiStatus(response) {
  return (response && response.data && response.data.statusCode >= 200 && response.data.statusCode < 300 )
}

export const getGlobalCookie = (name) => {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export const eraseGlobalCookie = (name) => {
  var date = new Date();
  date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));
  let expires = " expires=" + date.toUTCString();
  document.cookie = `${name}=; ${expires};`;
}

export const setGlobalCookie = (name, value, days) => {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + ';domain=sparta.aero' + expires + "; path=/";
}

export const getCookie = () => {
  var nameEQ = "mantenanceWarning=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export const clearCookie = (name, domain, path) => {
  var date = new Date(1560807962)
  var domain = domain || document.domain;
  var path = path || "/";
  document.cookie = name + "=; expires=" + date + "; domain=sparta.aero" + "; path=" + path;
};
export const downloadFileType = (fileData, fileName, fileExtension) => {
  if(window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(fileData, fileName+fileExtension);
      }else{
        const url = window.URL.createObjectURL(new Blob([fileData]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName+fileExtension);
        document.body.appendChild(link);
        link.click();
      }
}

export const formatterCurrency = (currency) => {
  return(new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: currency ? currency :"USD",
}))} 

export const five_digitHours = (value,prevValue) => {
  const numericValue = value.replace(/[^\d.]/g, '');
  const dotCount = (numericValue.match(/\./g) || [])?.length;
  const isValid = dotCount ? (numericValue.replace(".", "").length - dotCount <= 7 && regexConstants.numberWithDot.test(numericValue)) : value.length <= 5 && regexConstants.numberWithDot.test(numericValue)
  if (isValid || value === "") {
    return numericValue
  }
  return prevValue;
}

export const twoDecimalfn = (num) => {
  const value = Number(num);
  return isNaN(value) ? '' : value.toFixed(2);
};

// Display-only formatter (always 2 decimals)
export const twoDecimalFixed = (num) => {
  if (num === null || num === undefined || num === '') return '';
  const value = Number(num);
  if (isNaN(value)) return '';
  return value.toFixed(2);
};

export const fourDecimalfn = (num) => {
  return Number(num) % 1 === 0 ? Number(num).toString() : Number(num).toFixed(4);
};

// Normalizes tax_rate for API payloads: empty/cleared/invalid values become 0, valid numbers pass through.
export const normalizeTaxRate = (value) => {
  const numericValue = Number(value);
  return value === '' || value === null || value === undefined || isNaN(numericValue) ? 0 : numericValue;
};

export const convertTimeToDecimal = (value) => {
    const match = /^(\d{1,3}):([0-5][0-9])$/.exec(value);
    if (match) {
      const hours = parseInt(match[1], 10);
      const minutes = parseInt(match[2], 10);
      return (hours + minutes / 60).toFixed(6); 
    }
    return value;
};

export const normalizePrsvGroupedAmount = (amountObj, filteredLLPModule) => {
  if (!amountObj) return amountObj;
  const isGrouped = amountObj.llp !== undefined || amountObj.non_llp !== undefined;
  if (isGrouped) return amountObj;
  const grouped = { llp: {}, non_llp: {} };
  Object.entries(amountObj).forEach(([label, value]) => {
    const module = filteredLLPModule?.find((item) => item.label === label);
    const group = module?.isLlp === false ? 'non_llp' : 'llp';
    grouped[group][label] = value;
  });
  return grouped;
}

// Derives the { llp: {label: amount}, non_llp: {label: amount} } shape from claim_events[].modules
// for records where the API doesn't return a top-level prsv_claim_amount / prsv_amount_paid object.
export const buildPrsvGroupedAmountFromClaimEvents = (claimEvents, amountKey = 'claim_amount') => {
  if (!Array.isArray(claimEvents) || !claimEvents.length) return null;
  const grouped = { llp: {}, non_llp: {} };
  let hasModule = false;
  claimEvents.forEach((event) => {
    (event?.modules || []).forEach((mod) => {
      hasModule = true;
      const group = mod?.is_non_llp ? 'non_llp' : 'llp';
      grouped[group][mod?.module_name] = (grouped[group][mod?.module_name] || 0) + (Number(mod?.[amountKey]) || 0);
    });
  });
  return hasModule ? grouped : null;
}

// Sums the LLP amount off every claim_events[] entry marked is_llp_event: true,
// for records where the API doesn't return a top-level llp_claim_amount / llp_amount_paid.
// Shop visits can have multiple LLP events, so this must total across all of them, not just the first.
export const getLlpClaimEventAmount = (claimEvents, amountKey = 'claim_amount') => {
  if (!Array.isArray(claimEvents)) return undefined;
  const llpEvents = claimEvents.filter((event) => event?.maintenance_program?.is_llp_event === true);
  if (!llpEvents.length) return undefined;
  return llpEvents.reduce((total, event) => total + (Number(event?.[amountKey]) || 0), 0);
}

export const numberWithCommas = (x) => {
  if (x === null || x === undefined || x === '') return '--';
  const [integerPart, decimalPart] = x.toString().split('.');
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
}

// Rounds a monetary amount to a fixed decimal precision before display,
// preserving null/undefined/'' so numberWithCommas still falls back to '--'.
export const roundAmount = (x, decimals = 2) => {
  if (x === null || x === undefined || x === '') return x;
  const num = Number(x);
  if (isNaN(num)) return x;
  return num.toFixed(decimals);
}

// For cycle-based readings (CSN, FC): drops trailing ".00"-style zeros
// (22.00 -> 22) while keeping genuine decimals (22.50 -> 22.5).
export const formatCycles = (x) => {
  if (x === null || x === undefined || x === '') return '--';
  const num = parseFloat(x);
  if (isNaN(num)) return '--';
  return numberWithCommas(num);
}

export const getTextFieldRows = (value = "", maxRows, charsPerRow) => {
  if (!value) return 1;
  const lineBreaks = value.split("\n").length;
  const wrappedLines = Math.ceil(value.length / charsPerRow);
  return Math.min(Math.max(lineBreaks, wrappedLines, 1), maxRows);
};

